<script>
export let x;
export let y;
export let circleFill;
export let circleRadius = 5;
export let date;
export let value;
</script>

<g class="line-anno" transform="translate({x},{y})">
  <g class="circle" role="graphics-object">
    <circle r="{circleRadius}" fill={circleFill} />
  </g>
  <g class="line-anno-label line-anno-label-halo">
    <text dx="14" dy="0" class="line-anno-label-date">
      {date}
    </text>
    <text dx="14" dy="17" class="line-anno-label-value">
      {value}
    </text>
  </g>
  <g class="line-anno-label">
    <text dx="14" dy="0" class="line-anno-label-date">
      {date}
    </text>
    <text dx="14" dy="17" class="line-anno-label-value">
      {value}
    </text>
  </g>
</g>
